export const APP_MODES = {
  IMPERSONATED: 'impersonated',
  DEFAULT: 'user',
  READ_ONLY: 'readOnly',
};
